import { render } from "./KontaktPthPrishtine.vue?vue&type=template&id=1b746348"
import script from "./KontaktPthPrishtine.vue?vue&type=script&lang=js"
export * from "./KontaktPthPrishtine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__